<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content>
	<p>{{ data.message | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>
	<button mat-button color="primary" [mat-dialog-close]="true">{{ 'confirm' | translate }}</button>
</mat-dialog-actions>